import LocalStorage from "./classes/LocalStorage";
import CookieStorage from "./classes/CookieStorage";
import { Storage } from "./classes/Storage";

export default new Storage(new LocalStorage(), new CookieStorage());
